module.exports = __webpack_public_path__ + "img/idcard_2@2x.4000c706.png";